import {
  DETECT_CODE,
  GO_BACK,
  OTP_COUNT_DOWN,
  OTP_COUNT_DOWN_END,
  useLightBoxLoginContext,
} from 'components/light-box-login/use-light-box-login';
import { useInterval } from 'utils/time-helper';
import styles from 'components/light-box-login/index.module.scss';
import { Button, FormInput } from 'mochi-react-component';
import iconBack from 'images/icon-back.svg';
import React, { useCallback } from 'react';
import classnames from 'classnames/bind';

const SmsStep = ({ onDismiss }) => {
  const cx = classnames.bind(styles);
  const { state, dispatch, onSendCode, onResendOtp } = useLightBoxLoginContext();

  // for opt button
  useInterval(
    () => {
      if (state.otpCountDownTime <= 0) {
        dispatch({ type: OTP_COUNT_DOWN_END });
      } else {
        dispatch({ type: OTP_COUNT_DOWN });
      }
    },
    state.otpCountDownStart ? 1000 : null
  );

  const onDetectCode = e => {
    dispatch({
      type: DETECT_CODE,
      payload: e,
    });
  };

  const ResendText = () => {
    if (state.otpCountDownStart) {
      return <span className={styles.countdown}>{state.otpCountDownTime} 秒後可重新發送。</span>;
    }
    return (
      <Button type="text" theme="blue" onClick={onResendOtp}>
        點此重新發送
      </Button>
    );
  };

  const onGoBack = useCallback(() => {
    dispatch({
      type: GO_BACK,
    });
  }, [dispatch]);

  const stepCodeClass = cx({
    step: true,
    'step-code': true,
    in: state.codePageIn,
    out: state.codePageOut,
  });

  return (
    <div className={stepCodeClass}>
      <div className={styles.title}>歡迎回來</div>
      <div className={styles.desc}>登入你的麻吉付帳號，查看帳號設定。</div>
      <div className={styles.input}>
        <FormInput
          type="tel"
          label="簡訊驗證碼"
          placeholder="請輸入驗證碼"
          newText={state.code}
          maxLength={6}
          errorMsg={state.codeErrorMsg}
          onTextChange={onDetectCode}
          onKeyDown={e => {
            if (e.which === 9) {
              e.preventDefault();
            }
          }}
          onKeyPress={() => {
            if (state.codeAvailable) {
              onSendCode(onDismiss);
            }
          }}
        />
        <div className={styles.button}>
          <Button
            theme="black"
            disabled={!state.codeAvailable}
            onClick={() => {
              onSendCode(onDismiss);
            }}
          >
            登入
          </Button>
        </div>
      </div>
      <div className={styles.else}>
        已發送驗證碼至 {state.mobile}。<br />
        沒收到驗證碼嗎？ <ResendText />
      </div>
      <div className={styles.back}>
        <Button type="text" theme="black" size="with-icon" iconLeft={iconBack} onClick={onGoBack}>
          返回修改手機號碼
        </Button>
      </div>
    </div>
  );
};

export default SmsStep;
